module.exports = __webpack_public_path__ + "static/media/transition-orange.0e7f38e8.svg";